export default "__VITE_ASSET__CekQL7Oh__"